import type { SubscriptionOverview } from './subscription.api';

// One line about a store subscription on the Subscription page: in its free week, renewing on a
// date, or ending on a date (cancelled, Pro until then). Null for Free or a subscription Matcha gave.
export function subscriptionStatus(
  subscription: SubscriptionOverview['subscription'],
  now: Date = new Date()
): { kind: 'trial' | 'renews' | 'ends'; date: Date } | null {
  if (!subscription || (subscription.provider !== 'APP_STORE' && subscription.provider !== 'PLAY_STORE')) {
    return null;
  }
  const ends = subscription.currentPeriodEndsAt ? new Date(subscription.currentPeriodEndsAt) : null;
  if (!ends || ends <= now) {
    return null;
  }
  if (subscription.cancelAtPeriodEnd) {
    return { kind: 'ends', date: ends };
  }
  return { kind: subscription.status === 'TRIALING' ? 'trial' : 'renews', date: ends };
}

export const PLAN_COMPARE_ROWS = [
  'storage',
  'galleries',
  'gallerySettings',
  'webDownloads',
  'matchaMark',
  'ownAssistant',
] as const;
